import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["rows", "row", "template"]

  addRow(event) {
    event.preventDefault()

    const key = `${Date.now()}_${Math.floor(Math.random() * 1000)}`
    this.rowsTarget.insertAdjacentHTML("beforeend", this.templateTarget.innerHTML.replaceAll("NEW_RECORD", key))
  }

  removeRow(event) {
    event.preventDefault()

    const row = event.target.closest("[data-revenue-shares-target='row']")
    if (!row) return

    if (this.rowTargets.length <= 1) {
      this.clearRow(row)
    } else {
      row.remove()
    }
  }

  clearRow(row) {
    row.querySelectorAll("input").forEach((input) => {
      input.value = ""
      input.dispatchEvent(new Event("change", { bubbles: true }))
    })
  }
}
